import { gsap, SplitText } from "../LibrariesImport";
import { GlobalVariables } from "../GlobalVariables";

// Révélation caractère par caractère de l'intro de la bannière home — dédiée
// (pas via data-anim) car ni la famille "révélation" ni "apparition de texte"
// génériques ne couvrent un stagger par caractère.
export default class HomeBannerTextReveal {
	constructor(root) {
		this.el = root.querySelector(".banner-home-intro");
		if (!this.el) return;

		if (GlobalVariables.reducedMotion) {
			gsap.set(this.el, { opacity: 1 });
			return;
		}

		document.fonts.ready.then(() => {
			gsap.set(this.el, { opacity: 1 });

			SplitText.create(this.el, {
				type: "chars, words",
				autoSplit: true,
				onSplit: (self) => {
					return gsap.from(self.chars, {
						opacity: 0.3,
						duration: 0.4,
						stagger: 0.006,
						ease: "expo.out",
						scrollTrigger: {
							trigger: this.el,
							start: "top 85%",
						},
					});
				},
			});
		});
	}
}
